import { registerSW } from 'virtual:pwa-register'

export default function registerSw() {
    registerSW({ immediate: true }) // Registra o Service Worker automaticamente
    // if ('serviceWorker' in navigator) {
    //     window.addEventListener('load', () => {
    //         navigator.serviceWorker.register(
    //             '/workers/firebase-messaging-sw.js',
    //             {
    //                 scope: '/workers/',
    //             }
    //         )
    //     })
    // }
}
